// Runtime override from public/settings.js (window.__CONFIG__), which ships unbundled
// so the API target can be repointed per environment without a rebuild.
const runtimeConfig = (typeof window !== "undefined" && window.__CONFIG__) || {};

const config = {
  baseUrl: runtimeConfig.baseUrl || "https://uhroessapi.peopleguru.dev/api",
  USERNAME: "",
  PASSWORD: "",
  certSealId: "DigiCertClickID_KyhqI1bk",
  loginURL: "/getessmain",
  eepasswordURL: "/eepassword",
  emergcontactsURL: "/emergcontacts",
  notificationelectionURL: "/notificationelection",
  entitlements: "/entitlements",
  ddprintvoucher: "/ddprintvoucher",
  paystub: "/paystub",
  getEducationDetails: "/eeeducation",
  salaryHistoryURL: "/salaryhistory",
  trnhistory: "/trnhistory",
  trnenrollmentURL: "/trnenrollment",
  eeemailaddr: "/eeemailaddr",
  dependentsURL: "/dependents",
  eeInfoURL: "/eeinfo",
  eeDirectorySearch: "/eedirectory",
  VolSelfIdDisURL: "/VolSelfIdDis",
  eeconsentURL: "/eeconsent",
  jobreviewsURL: "/jobreviews",
  eeCertifURL: "/eeCertif",
  addressInformationURL: "/eeaddress",
  eefileURL: "/eefile",
  benefitStatementURL: "/benefitsSumm",
  eedirdep: "/eedirdep",
  totcompstateURL: "/totCompState",
  eeSkillsURL: "/eeskills",
  getDocURL: "/getDoc",
  w2HistoryURL: "/W2History",
  formC1095URL: "/ee1095form",
  benefits: "/benefits",
  bftBeneficiariesURL: "/beneficiaries",
  renderHtml: "/renderHtml",
  dashboardURL: "/dashboard",
  paycalculator: "/paycalculator",
  retdedURL: "/retded",
  esssidebarURL: "/esssidebar",
  symmetryW4: "/SymmetryW4",
  I9Info: "/I9Info",
  I9Info_NotEligDocUpload: "/I9Info_NotEligDocUpload",
  getCertSeal: "/getCertSeal",
  getSSLSeal: "/getSSLSeal",
  onboardingURL: "/onboarding",
  OnboardCompleteURL: "/onboarding",
  getSrcFile: "/getSSLSeal",
  w4infoURL: "/w4info",
  lifeEvents: "/lifeEvents",
  getLoginImage: "/getLoginImage",
  getLoginContent: "/getcustomlogin",
  getEssLanguage: "/getessLanguage",
  getCustomerPage: "/getCustomerPage",
  setTranslateText: "/setTranslateText",
  getGeneratedDoc: "/getGeneratedDoc"
};

export default config;